import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	AboutUsPageFilter,
	InfoRequestDTO,
	InformationAboutUs,
	InformationAboutUsDTO,
	SortAboutUsListDTO,
} from '../DTO/information/aboutUs.interface';

export const aboutUsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAboutUsList: builder.query<
			SuccessResponse<Paginated<InformationAboutUsDTO>>,
			AboutUsPageFilter
		>({
			query: (body) => ({
				url: `/web/information/about-us/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['AboutUsList'],
		}),
		sortAboutUsList: builder.mutation<
			SuccessResponse<any>,
			{ sortList: SortAboutUsListDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/about-us/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['AboutUsList'],
		}),
		createAboutUs: builder.mutation<SuccessResponse<any>, InfoRequestDTO>({
			query: (body) => ({
				url: `/web/information/about-us`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['AboutUsList'],
		}),
		updateAboutUs: builder.mutation<SuccessResponse<any>, InfoRequestDTO>({
			query: (body) => ({
				url: `/web/information/about-us`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['AboutUsDetail'],
		}),
		getAboutUsDetail: builder.query<
			SuccessResponse<InformationAboutUs>,
			string
		>({
			query: (id) => ({
				url: `/web/information/about-us/${id}`,
				method: 'GET',
			}),
			providesTags: ['AboutUsDetail'],
		}),
		deleteAboutUs: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/information/about-us/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useGetAboutUsListQuery,
	useSortAboutUsListMutation,
	useCreateAboutUsMutation,
	useUpdateAboutUsMutation,
	useGetAboutUsDetailQuery,
	useDeleteAboutUsMutation,
} = aboutUsApiSlice;
